import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IOrganizerState }      from 'Redux/Slices/Organizer/OrganizerSlice';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const deleteOrganizerRequest = (state: Draft<IOrganizerState>, { type }: PayloadAction<{ id: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const deleteOrganizerSuccess = (state: Draft<IOrganizerState>, { type, payload }: PayloadAction<{
  id: string
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  const newEntries = { ...state.entries };
  if(payload.id in newEntries) {
    delete newEntries[payload.id];
  }
  state.entries = newEntries;
};

export const deleteOrganizerFailure = (state: Draft<IOrganizerState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
